export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7529.b5c399a1.jpg";